import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import store from '@/store'
import Dashboard from '../views/Dashboard.vue'
import ProspectCreateExternal from '../views/prospect/ProspectCreateExternal.vue'
import Login from '../views/auth/Login.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

import {loginMeta, defaultMeta, guestMeta} from '@/config/router'

Vue.use(VueRouter)

function loadView(folder: any, view: any) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${folder}/${view}.vue`)
}

const routes: Array<RouteConfig> = [
  {
    path: '/auth/login',
    name: 'Login',
    component: Login,
    meta: loginMeta
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: defaultMeta
  },
  {
    path: '/mco',
    name: 'Mco',
    component: ProspectCreateExternal,
    meta: guestMeta
  },
  {
    path: '/config',
    name: 'Config',
    component: loadView('config', 'Config'),
    meta: defaultMeta,
    redirect: '/config/sujet',
    children: [
      /* Sujet routes */
      {
        path: 'sujet',
        name: 'SujetList',
        component: loadView('config/sujet', 'SujetList'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'SujetCreate',
            component: loadView('config/sujet', 'SujetCreate'),
            meta: defaultMeta
          },
          {
            path: ':id/update',
            name: 'SujetUpdate',
            component: loadView('config/sujet', 'SujetUpdate'),
            meta: defaultMeta
          }
        ]
      },
      /* BlocText routes */
      {
        path: 'bloctext',
        name: 'BlocTextList',
        component: loadView('config/bloctext', 'BlocTextList'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'BlocTextCreate',
            component: loadView('config/bloctext', 'BlocTextCreate'),
            meta: defaultMeta
          },
          {
            path: ':id/update',
            name: 'BlocTextUpdate',
            component: loadView('config/bloctext', 'BlocTextUpdate'),
            meta: defaultMeta
          }
        ]
      },
      /* BlocSms routes */
      {
        path: 'blocsms',
        name: 'BlocSmsList',
        component: loadView('config/blocsms', 'BlocSmsList'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'BlocSmsCreate',
            component: loadView('config/blocsms', 'BlocSmsCreate'),
            meta: defaultMeta
          },
          {
            path: ':id/update',
            name: 'BlocSmsUpdate',
            component: loadView('config/blocsms', 'BlocSmsUpdate'),
            meta: defaultMeta
          }
        ]
      },
      /* Mail Document Generique routes */
      {
        path: 'documentGenerique',
        name: 'DocumentGenerique',
        component: loadView('config/documentGenerique', 'DocumentGenerique'),
        meta: defaultMeta
      },
      /* Options routes */
      {
        path: 'option',
        name: 'OptionList',
        component: loadView('config/option', 'OptionList'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'OptionCreate',
            component: loadView('config/option', 'OptionCreate'),
            meta: defaultMeta
          },
          {
            path: ':id/update',
            name: 'OptionUpdate',
            component: loadView('config/option', 'OptionUpdate'),
            meta: defaultMeta
          }
        ]
      }
    ]
  },
  {
    path: '/changeConseillerInfo',
    name: 'ChangeConseillerInfo',
    component: loadView('common', 'ChangeConseillerInfo'),
    meta: defaultMeta
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: loadView('common', 'ChangePassword'),
    meta: defaultMeta
  },
  /* Prospect routes */
  {
    path: '/prospect',
    name: 'prospectList',
    component: loadView('prospect', 'ProspectList'),
    meta: defaultMeta
  },
  {
    path: '/prospect/create',
    name: 'prospectCreate',
    component: loadView('prospect', 'ProspectCreate'),
    meta: defaultMeta
  },
  {
    path: '/prospect/createFast',
    name: 'prospectCreateFast',
    component: loadView('prospect', 'ProspectCreateFast'),
    meta: defaultMeta
  },
  {
    path: '/prospect/:id',
    name: 'prospectDetail',
    component: loadView('prospect', 'ProspectDetail'),
    redirect: '/prospect/:id/fiche',
    meta: defaultMeta,
    children: [
      {
        path: 'fiche',
        name: 'prospectFiche',
        component: loadView('prospect', 'ProspectFiche'),
        meta: defaultMeta
      },
      {
        path: 'formulaire',
        name: 'prospectFormulaire',
        component: loadView('prospect', 'ProspectFormulaire'),
        meta: defaultMeta
      },
      {
        path: 'parrainage',
        name: 'prospectParrainage',
        component: loadView('prospect', 'ProspectParrainage'),
        meta: defaultMeta
      },
      {
        path: 'contact',
        name: 'prospectContact',
        component: loadView('prospect', 'ProspectContact'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'prospectContactCreate',
            component: loadView('prospect', 'ProspectContactCreate'),
            meta: defaultMeta
          },
          {
            path: ':contactId/update',
            name: 'prospectContactUpdate',
            component: loadView('prospect', 'ProspectContactUpdate'),
            meta: defaultMeta
          }
        ]
      },
      {
        path: 'echange',
        name: 'prospectEchange',
        component: loadView('prospect', 'ProspectEchange'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'prospectEchangeCreate',
            component: loadView('prospect', 'ProspectEchangeCreate'),
            meta: defaultMeta
          },
          {
            path: ':echangeId/update',
            name: 'prospectEchangeUpdate',
            component: loadView('prospect', 'ProspectEchangeUpdate'),
            meta: defaultMeta
          }
        ]
      },
      {
        path: 'proposition',
        name: 'prospectProposition',
        component: loadView('prospect', 'ProspectProposition'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'prospectPropositionCreate',
            component: loadView('prospect', 'ProspectPropositionCreate'),
            meta: defaultMeta
          },
          {
            path: ':propositionId/update',
            name: 'prospectPropositionUpdate',
            component: loadView('prospect', 'ProspectPropositionUpdate'),
            meta: defaultMeta
          }
        ]
      },
      {
        path: 'client',
        name: 'prospectClient',
        component: loadView('prospect', 'ProspectClient'),
        meta: defaultMeta
      },
      {
        path: 'cloture',
        name: 'prospectCloture',
        component: loadView('prospect', 'ProspectCloture'),
        meta: defaultMeta
      },
      {
        path: 'alerte',
        name: 'prospectAlerte',
        component: loadView('prospect', 'ProspectAlerte'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'prospectAlerteCreate',
            component: loadView('prospect', 'ProspectAlerteCreate'),
            meta: defaultMeta
          },
          {
            path: ':alerteId/update',
            name: 'prospectAlerteUpdate',
            component: loadView('prospect', 'ProspectAlerteUpdate'),
            meta: defaultMeta
          }
        ]
      },
      {
        path: 'essai',
        name: 'prospectEssai',
        component: loadView('prospect', 'ProspectEssai'),
        meta: defaultMeta,
        children: [
          {
            path: 'create',
            name: 'prospectEssaiCreate',
            component: loadView('prospect', 'ProspectEssaiCreate'),
            meta: defaultMeta
          },
          {
            path: ':essaiId/update',
            name: 'prospectEssaiUpdate',
            component: loadView('prospect', 'ProspectEssaiUpdate'),
            meta: defaultMeta
          }
        ]
      },
      {
        path: 'document',
        name: 'prospectDocument',
        component: loadView('prospect', 'ProspectDocument'),
        meta: defaultMeta,
        children: [
          {
            path: ':documentId/update',
            name: 'prospectDocumentUpdate',
            component: loadView('prospect', 'ProspectDocumentUpdate'),
            meta: defaultMeta
          }
        ]
      }
    ]
  },
  /* Echange routes */
  {
    path: '/echange',
    name: 'echangeList',
    component: loadView('echange', 'EchangeList'),
    meta: defaultMeta
  },
  /* Groupe routes */
  {
    path: '/groupe',
    name: 'groupeList',
    component: loadView('groupe', 'GroupeList'),
    meta: defaultMeta,
    children: [
      {
        path: 'create',
        name: 'groupeCreate',
        component: loadView('groupe', 'GroupeCreate'),
        meta: defaultMeta
      },
      {
        path: ':id/update',
        name: 'groupeUpdate',
        component: loadView('groupe', 'GroupeUpdate'),
        meta: defaultMeta
      }
    ]
  },
  /* Catch */
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Navigation Guard

router.beforeEach((to, from, next) => {
  // Require Auth
  const storeRef: any = store
  if (to.meta.requireAuth) {
    if (storeRef.state.auth.token !== null) {
      if (storeRef.state.auth.me && to.meta.roles) {
        const isAuthorized = to.meta.roles.includes(storeRef.state.auth.me.CODE_ROLE_CONSEILLER)
        if (!isAuthorized) {
          next('/mco')
        } else {
          if (storeRef.state.ui.isEdit) {
            router.app.$dialogs
              .confirm(
                'Voulez vous quittez cette page ? les modifications que vous venez de faire seront perdues',
                optionsVslim
              )
              .then(({ok}) => {
                if (ok) {
                  store.dispatch('ui/resetIsEditAction')
                  next()
                } else {
                  store.dispatch('ui/resetIsEditAction')
                }
              })
            return false
          } else {
            next()
          }
        }
      }
    } else {
      // store.dispatch('saveEntryPoint', to)
      next('auth/login')
    }
  } else {
    next()
  }
})

export default router
